import { get, writable } from "svelte/store";
import API from "../../API/API";
import LoadState from "../../Enums/LoadState";
import ColorHelper from "../../Helpers/ColorHelper";
import GeoHelper from "../../Helpers/GeoHelper";
import roundFloat from "../../Helpers/Misc/roundFloat";
import MapDataSource from "../../Map/Enums/MapDataSource";
import MapLayer from "../../Map/Enums/MapLayer";
import MapLayerGroup from "../../Map/Enums/MapLayerGroup";
import MapLayerManager from "../../Map/MapLayerManager";
import PopupStore from "../../Map/Popup/PopupStore";
import MapStore from "../../Map/Store";

const CablesStore = {
	meta: {
		loadState: writable(LoadState.INIT),
		visible: writable(false),
		visibility: {
			lines: writable(true),
			buffers: writable(true),
			points: writable(true)
		},
		error: writable(""),
		lastUpdated: writable(0),
		mapLayersInitted: writable(true)
	},
	results: {
		britned: {
			lines: writable(null),
			buffers: writable(null),
			points: writable(null)
		}
	},
	actions: {
		initMap: (map) => {
			if (get(CablesStore.meta.mapLayersInitted)) {
				return;
			}
			map.addSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_LINES, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_BUFFERS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_POINTS, {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});

			map.addLayer({
				id: MapLayer.NATIONALGRID_UNDERSEA_CABLE_LINES,
				source: MapDataSource.NATIONALGRID_UNDERSEA_CABLE_LINES,
				type: "line",
				layout: {
					"line-join": "round",
					"line-cap": "round"
				},
				paint: {
					"line-color": "#000",
					"line-width": 2,
					"line-opacity": 1.0
				}
			});
			map.setLayerZoomRange(MapLayer.NATIONALGRID_UNDERSEA_CABLE_LINES, 0, 24);

			map.addLayer({
				id: MapLayer.NATIONALGRID_UNDERSEA_CABLE_BUFFERS,
				source: MapDataSource.NATIONALGRID_UNDERSEA_CABLE_BUFFERS,
				type: "fill",
				layout: {},
				paint: {
					"fill-color": "rgba(255, 20, 20, 0.5)",
					"fill-opacity": ["interpolate", ["linear"], ["zoom"], 1, 0.2, 8, 0.5],
					"fill-outline-color": "black"
				}
			});
			map.setLayerZoomRange(MapLayer.NATIONALGRID_UNDERSEA_CABLE_BUFFERS, 0, 24);

			map.addLayer({
				id: MapLayer.NATIONALGRID_UNDERSEA_CABLE_POINTS,
				source: MapDataSource.NATIONALGRID_UNDERSEA_CABLE_POINTS,
				// type: "symbol",
				type: "circle",
				// layout: Layout.rfVesselPoints,
				layout: {
					// "icon-image": "dot-11",
					// "icon-size": 1,
					// "icon-allow-overlap": false,
					"circle-sort-key": ["to-number", ["get", "sortKey"], 5]
				},
				paint: {
					// "icon-opacity": 1.0
					"circle-radius": ["to-number", ["get", "radius"], 5],
					// "circle-color": "rgba(255, 0, 0, 1.0)",
					"circle-color": ["string", ["get", "color"], "#ffffff"]
					// "icon-color": ["string", ["get", "color"], "#ffffff"],
					// "icon-halo-color": ["string", ["get", "color"], "#ffffff"]
					// "circle-stroke-color": "rgba(245, 245, 245, 0.3)",
					// "circle-allow-overlap": false
					// "circle-stroke-width": 1.5
				}
			});
			map.setLayerZoomRange(MapLayer.NATIONALGRID_UNDERSEA_CABLE_POINTS, 0, 24);

			MapLayerManager.addLayerGroup(
				MapLayerGroup.NATIONALGRID_UNDERSEA_CABLES,
				[
					MapLayer.NATIONALGRID_UNDERSEA_CABLE_BUFFERS,
					MapLayer.NATIONALGRID_UNDERSEA_CABLE_LINES,
					MapLayer.NATIONALGRID_UNDERSEA_CABLE_POINTS
				],
				[
					MapDataSource.NATIONALGRID_UNDERSEA_CABLE_BUFFERS,
					MapDataSource.NATIONALGRID_UNDERSEA_CABLE_LINES,
					MapDataSource.NATIONALGRID_UNDERSEA_CABLE_POINTS
				]
			);

			CablesStore.meta.mapLayersInitted.set(true);
		},
		deinitMap: () => {
			if (!get(CablesStore.meta.mapLayersInitted)) {
				return;
			}
			MapLayerManager.removeLayerGroup(MapLayerGroup.NATIONALGRID_UNDERSEA_CABLES);
			CablesStore.meta.mapLayersInitted.set(false);
		},
		init: () => {
			// Already initted
			if (get(CablesStore.meta.loadState) !== LoadState.INIT) {
				const lines = get(CablesStore.results.britned.lines);
				const buffers = get(CablesStore.results.britned.buffers);
				const points = get(CablesStore.results.britned.points);
				const map = MapStore.helpers.getMap();
				map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_LINES).setData(lines);
				map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_BUFFERS).setData(buffers);
				map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_POINTS).setData(points);
				return;
			}

			CablesStore.meta.loadState.set(LoadState.LOADING);

			const onEnterLine = (e) => {
				if (e.features.length > 0) {
					const coords = [e.lngLat.lng, e.lngLat.lat];
					const props = {
						Name: "BritNed"
					};

					PopupStore.actions.custom(props, coords, true);
				}
			};

			const onEnterPoint = (e) => {
				if (e.features.length > 0) {
					const props = e.features[0].properties;
					const coords = [e.lngLat.lng, e.lngLat.lat];

					const newProps = {
						Name: "BritNed",
						"Kilometre Post": roundFloat(props.KP, 2) + " km",
						"Burial Depth": roundFloat(props.burial_depth, 2) + " mtrs",
						"Mean Sea Bed": props["2020_VBW_MSB"] + " mtrs",
						"Mean Sea Level to Cable": props["2021_PRIMO_Fixed ToP"] + " mtrs"
					};
					if (typeof props.risk !== "undefined") {
						newProps["Trawling within 500m"] = Math.floor(props.fishing_nearby) + " vessels";
						newProps["Risk Level"] = props.risk;
						newProps["Burial Depth Risk"] = Math.round(props.burial_depth_risk);
						newProps["Fishing Nearby Risk"] = Math.round(props.fishing_nearby_risk);
					}
					if (props.Burial_depth < 0) {
						newProps["Burial Depth"] += " (EXPOSED!)";
					}
					// props.

					PopupStore.actions.custom(newProps, coords, true);
					e.preventDefault();
				}
			};
			const onLeavePoint = (e) => {
				PopupStore.actions.custom({}, null, false);
			};

			const map = MapStore.helpers.getMap();
			map.on("mouseenter", MapLayer.NATIONALGRID_UNDERSEA_CABLE_POINTS, onEnterPoint);
			map.on("mousemove", MapLayer.NATIONALGRID_UNDERSEA_CABLE_POINTS, onEnterPoint);
			map.on("mouseleave", MapLayer.NATIONALGRID_UNDERSEA_CABLE_POINTS, onLeavePoint);

			const promises = [
				API.getDatasetParsedJSON("ng_cables_britned"),
				API.getDatasetParsedJSON("ng_cables_britned_points")
			];
			Promise.all(promises)
				.then((responses) => {
					const britnedGeojson = responses[0];
					const britnedPoints = responses[1];

					const lines = GeoHelper.emptyGeoJson([britnedGeojson.features[0]]);
					const buffers = GeoHelper.emptyGeoJson([britnedGeojson.features[1]]);

					const riskColorKey = [
						ColorHelper.getRiskLevelColor(0), // white
						ColorHelper.getRiskLevelColor(1), // light green "#1baa36", //
						ColorHelper.getRiskLevelColor(2), // yellow  "#e9dc00",
						ColorHelper.getRiskLevelColor(3), // orange",
						ColorHelper.getRiskLevelColor(4), // lightred, "#ff0000",
						ColorHelper.getRiskLevelColor(5) // darkred "#cc0040"
					];

					const points = GeoHelper.emptyGeoJson(
						britnedPoints.map((item) => {
							const feature = GeoHelper.featureAt(item.lon, item.lat, item);

							feature.properties.color = "#ffffff";
							if (typeof feature.properties.risk !== "undefined") {
								feature.properties.color = riskColorKey[parseInt(feature.properties.risk)];
							}
							feature.properties.sortKey = parseInt(feature.properties.risk);
							feature.properties.radius = parseInt(feature.properties.risk) + 3;
							return feature;
						})
					);

					const map = MapStore.helpers.getMap();
					if (map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_LINES)) {
						map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_LINES).setData(lines);
					}
					if (map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_BUFFERS)) {
						map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_BUFFERS).setData(buffers);
					}
					if (map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_POINTS)) {
						map.getSource(MapDataSource.NATIONALGRID_UNDERSEA_CABLE_POINTS).setData(points);
					}

					CablesStore.results.britned.lines.set(lines);
					CablesStore.results.britned.buffers.set(buffers);
					CablesStore.results.britned.points.set(points);
					CablesStore.meta.loadState.set(LoadState.LOADED);

					MapLayerManager.updateVisibleLayers();
				})
				.catch((error) => {
					console.error(error);
					CablesStore.meta.error.set(error);
					CablesStore.meta.loadState.set(LoadState.INIT);
				});
		}
	},
	helpers: {}
};

export default CablesStore;
